import React from 'react';

interface ListSkeletonProps {
  rows?: number;
}

export const ListSkeleton: React.FC<ListSkeletonProps> = ({ rows = 10 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <tr
          key={index}
          className="animate-pulse border-t border-white border-opacity-20"
        >
          <td className="text-center w-24 py-2 align-left">
            <div className="bg-zinc-800 h-6 w-6 rounded-md mx-auto"></div>
          </td>
          <td className=" w-24 py-2 align-left">
            <div className="bg-zinc-800 h-6 rounded-md w-6"></div>
          </td>
          <td className="pl-4 py-2 align-left">
            <div className="bg-zinc-800 h-6 rounded-md w-auto mr-4"></div>
          </td>
          <td className="py-2 align-left">
            <div className="bg-zinc-800 h-6 rounded-md w-3/4 mr-4"></div>
          </td>
          <td className="py-2 align-left">
            <div className="bg-zinc-800 h-6 rounded-md w-auto mr-4"></div>
          </td>
        </tr>
      ))}
    </>
  );
};
